export default {
  "5986d9ac4261dc68f5dd403cec97ef5a": "查询失败了",
  "bf8711b086c6f886c938b4ba2b582295": "选择地址失败",
  "aa413d4c5a5ffc68680171d4a2f96045": "您的地址已经超过20个，请在原有地址编辑修改或者删除后新增",
  "2396a131051209fbd19601705f990d1c": "默认地址修改成功",
  "852b0aaf2b2fdeae49d4e743a40c3bce": "默认地址修改失败",
  "903da4a3d87dbb5d2003b7a574fbd6b4": "地址删除成功",
  "56091dadb19ab914b66af333835cbc54": "地址删除失败",
  "abfacaab19409e0b99fec1c75f47bf17": "订单地址修改成功",
  "562dae1f882a6098f7a254dadb4313ad": "订单地址修改失败",
  "d0a4a1fcdf49f28fb2d51745f1160648": "按钮点击",
  "560b5fb04e17fa801b49da28c74ed89c": "编辑",
  "e83de8b6a6e6893f9244634abbae6b87": "您还没有收货地址哦～",
  "bbb89af8b403928861ef63b7da6cd2d9": "新增",
  "76728378c0a571734342f397d7471171": "收货地址",
  "d7b5325d13c591c3865d1a6bee68c012": "新增收货地址"
}
